import { FolderTreeItem } from "../useQueryFolderTree";

export function getOwnerIdsFromTree(
  folders: FolderTreeItem[],
  _ownerIds?: Set<number>,
) {
  const ownerIds = _ownerIds || new Set();

  for (const folder of folders || []) {
    if (folder?.children?.length) {
      getOwnerIdsFromTree(folder.children as FolderTreeItem[], ownerIds);
    }
    if (folder.ownerId) {
      ownerIds.add(folder.ownerId);
    }
  }

  return [...ownerIds];
}
